import React from 'react';

import { claimBarCellMaxWidth } from '~/components/ClaimPage/ClaimPageBar/ClaimPageBarUtils';
import { ContactEntity } from '~/components/Contact';
import { useIncidentConfiguration } from '~/components/hooks/useIncidentConfiguration';
import { getBrokerFieldConfig } from '~/components/Policy/GenericPolicy/PolicyDetails/brokerFieldConfig';
import { usePolicy } from '~/components/PolicyContainer';

import GenericClaimBarField from './GenericClaimBarField';

type BrokerProps = {
  displayName?: string;
};

const Broker = ({ displayName = 'Broker' }: BrokerProps) => {
  const { policy } = usePolicy();
  const { incidentConfiguration } = useIncidentConfiguration();

  const brokerConfig = getBrokerFieldConfig(incidentConfiguration);
  if (!brokerConfig?.active) {
    return null;
  }

  return (
    <GenericClaimBarField title={displayName}>
      {policy?.broker_contact_id ? (
        <ContactEntity
          contactId={policy.broker_contact_id}
          contactDisplayName={policy.broker_contact_full_name}
          maxWidth={claimBarCellMaxWidth}
        />
      ) : null}
    </GenericClaimBarField>
  );
};

export default Broker;
